import { logger } from '@src/utils/misc/logger';

// Sanitize markdown text to prevent pathological patterns from crashing the frontend.
export function sanitizeMarkdown(markdown: string): string {
  if (!markdown || typeof markdown !== 'string') {
    return markdown;
  }

  let text = markdown;
  let sanitized = false;

  // 2. Fix pathological table dividers and extremely wide tables
  // Process line by line to handle both issues
  const lines = text.split('\n');
  const fixedLines = lines.map((line) => {
    // CRITICAL: Check for excessive dashes first (pathological pattern)
    // This catches lines like: | :----{1000+ dashes}
    const dashCount = (line.match(/[-]/g) || []).length;
    if (dashCount > 250) {
      sanitized = true;
      logger.error(`[Nexa] Line with ${dashCount} dashes detected and truncated`);
      // If it looks like a table line (has pipes), replace with simple divider
      if (line.includes('|')) {
        const pipeCount = (line.match(/\|/g) || []).length;
        const numCells = Math.max(1, pipeCount - 1);
        return '| ' + Array(numCells).fill('---').join(' | ') + ' |';
      }
      // Otherwise just truncate the line
      return '*[Content truncated - excessive length]*';
    }

    return line;
  });

  text = fixedLines.join('\n');

  if (sanitized) {
    logger.log(
      `[Nexa] Markdown sanitization applied - original length: ${markdown.length}, final length: ${text.length}`,
    );
  }

  return text;
}
